<template>
    <div class="product-check-view">
        <b-card v-if="data !== null && data.data !== null">
            <b-table stacked :items="productHeaderData" :fields="productHeaderFields" caption-top>
                <template v-slot:table-caption>{{ data.data.items[0].serialNo1 }} Seri numaralı ürün detayları.</template>
            </b-table>
        </b-card>
        <b-card v-if="data !== null && !data.success" bg-variant="danger" text-variant="white" class="text-center">
            <b-card-text><v-icon name="exclamation-circle"/> {{ data.message }}</b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'ProductCheckView',
    props: {
        data: Object
    },
    computed: {
        productHeaderFields() {
            return [
                { key: 'code', label: 'Ürün Kodu' },
                { key: 'description', label: 'Açıklama' },
                { key: 'warrantyStatusText', label: 'Garanti Durumu' }
            ];
        },
        productHeaderData() {
            return this.data.data.items;

        },
    }
}
</script>

<style scoped>

</style>